export default {
  state: {
    dataTypeList: [
      { lable: 'Personal', value: 'Personal', icon: 'user-blue' },
      { lable: 'Sensitive', value: 'Sensitive', icon: 'eye-off-blue' },
      { lable: 'Financial', value: 'Financial', icon: 'wallet-blue' },
      { lable: 'Health', value: 'Health', icon: 'health-blue' },
      { lable: 'Protected', value: 'Protected', icon: 'lock-icon' },
    ],

    dataTypeContent: [
      { lable: 'Data breach notification to customers', content: '72 hours' },
      {
        lable: 'Encryption algorithms',
        content: 'Data at rest: AES-256 . Data in transit: : AES-256',
      },
      { lable: 'Hosting geolocation', content: 'Belgium, USA' },
      { lable: 'Latest penetration date', content: '1/2/2023' },
      {
        lable: 'Authentication methods',
        content: 'User/password, SSO (Google, Microsoft, Okta),  MFA',
      },
      {
        lable: 'Integrations (3)',
        content: 'Slack, Microsoft Teams, Confluence',
      },
    ],
  },
  mutations: {},
  actions: {},
  getters: {
    GET_DATA_TYPE_LIST(state) {
      return state.dataTypeList
    },
    GET_DATA_TYPE_CONTENT(state) {
      return state.dataTypeContent
    },
  },
}
